module.exports = __webpack_public_path__ + "img/logoSechs.b11644f6.jpg";